import { render, staticRenderFns } from "./GuilderNavPage.vue?vue&type=template&id=38c7d764&"
import script from "./GuilderNavPage.vue?vue&type=script&lang=ts&"
export * from "./GuilderNavPage.vue?vue&type=script&lang=ts&"
import style0 from "./GuilderNavPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports